import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/builds/out/node_modules/css-loader/dist/runtime/api.js'
import '/builds/out/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/builds/out/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import planningStages from '~root/src/App.vue?shadow'
window.customElements.define('planning-stages', wrap(Vue, planningStages))